import {ReactElement} from 'react';

type Props = {
    children: ReactElement | ReactElement[];
}

export const FormControls: React.FC<Props> = ({children}) => (
    <div className='tw-grid tw-grid-cols-1 tw-gap-2'>
        {children}
    </div>
);